var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Prisma, prisma } from '@workalizer/db';
import { AnalyticPeriodsEnum, DriveEventActionEnum } from '@workalizer/shared';
import { getSelectQueryRawFilterByDate } from '@workalizer/shared/utils';
export var documentUpdateActions = [
    DriveEventActionEnum.DOCUMENT_EDIT,
    DriveEventActionEnum.DOCUMENT_RENAME,
    DriveEventActionEnum.DOCUMENT_CHANGE_ACCESS,
    DriveEventActionEnum.DOCUMENT_RESTORE
];
export var getDocumentEvents = function (workspaceId, userIds, dateFrom, dateTo, timeZone, options) { return __awaiter(void 0, void 0, void 0, function () {
    var sqlGroupBy;
    var _a;
    return __generator(this, function (_b) {
        if (userIds.length === 0) {
            return [2 /*return*/, []];
        }
        sqlGroupBy = (_a = options === null || options === void 0 ? void 0 : options.sqlGroupBy) !== null && _a !== void 0 ? _a : AnalyticPeriodsEnum.DAY;
        return [2 /*return*/, prisma.$queryRaw(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    SELECT \n      ", " as date, \n      user_id as \"userId\", \n      action, \n      document_id as \"documentId\" \n    FROM document_event\n    WHERE workspace_id = ", "\n      AND date BETWEEN ", " AND ", "\n      AND user_id IN (", ")\n      AND action IN (", ")\n    ORDER BY date ASC\n  "], ["\n    SELECT \n      ", " as date, \n      user_id as \"userId\", \n      action, \n      document_id as \"documentId\" \n    FROM document_event\n    WHERE workspace_id = ", "\n      AND date BETWEEN ", " AND ", "\n      AND user_id IN (", ")\n      AND action IN (", ")\n    ORDER BY date ASC\n  "])), getSelectQueryRawFilterByDate({ timeZone: timeZone, groupBy: sqlGroupBy }), workspaceId, new Date(dateFrom), new Date(dateTo), Prisma.join(userIds), Prisma.join(__spreadArray([
                DriveEventActionEnum.DOCUMENT_CREATE
            ], documentUpdateActions, true)))];
    });
}); };
var templateObject_1;
